import React from "react";
import { Link } from "react-router-dom";
import { Money, Time, Parcel, Layananimg2, Lawfirm, Legalbisnis, Agro, HeroImage2, HeroImage3, HeroImage4, HeroImage5, HeroImage6, HeroImage7, HeroImage8 } from "../assets/images";
import { FaPeopleGroup } from "react-icons/fa6";

function Layanan() {
  return (
    <div className="md:pt-12 pt-14">
      <h1 data-aos="fade-up" className="text-xl bg-primary text-white text-center py-10 md:px-32 px-8">
        Mayoritas pengusaha memiliki keterbatasan pengetahuan mengenai aspek hukum dalam dunia bisnis.
        TEMPS berperan sebagai solusi bagi para wirausaha dengan memberikan pendekatan preventif untuk
        mengatasi berbagai permasalahan bisnis Anda, melalui layanan konsultasi hukum, seperti perlindungan
        merek, izin operasional, manufaktur, dan manajemen logistik.
      </h1>


      {/* Branding */}
      <div className="flex w-10/12 mx-auto pt-10">
        <section>
          <div className="container py-4 mx-auto bg-white shadow-lg rounded-lg max-w-7xl sm:p-6 lg:p-8 ">
            <div className="flex flex-wrap -mx-8">
              <div className="w-11/12 ml-7 lg:ml-0 lg:w-1/2 ">
                <div data-aos="fade-right" className="pb-12 mb-12 border-b lg:mb-0 lg:pb-0 lg:border-b-0">
                  <h2 className="flex-1 px-6 mt-3 font-bold text-5xl text-primary md:ml-0 ml-3">Our Services</h2>
                  <div
                    style={{
                      backgroundImage: `url(${Layananimg2})`,
                      backgroundPosition: "center",
                      backgroundAttachment: "scroll",
                      backgroundSize: "cover",
                    }}
                    className="md:w-full md:flex-row flex-col w-full mx-auto hidden md:flex justify-center items-center py-48 mt-16 sm:hidden"
                  >
                  </div>

                </div>
              </div>
              <div className="w-full px-8 lg:w-1/2 md:mx-0 mx-4">
                <ul className="space-y-6">
                  <li data-aos="fade-left" className="flex -mx-4">
                    <div className="px-4">
                      <span className="flex items-center justify-center w-16 h-16 mx-auto text-2xl font-bold text-secondary rounded-full font-heading bg-primary">
                        1
                      </span>
                    </div>
                    <div className="px-4 text-primary">
                      <h3 className="my-2 text-xl font-semibold text-secondary">
                        Profesional
                      </h3>
                      <p className="leading-loose text-primary text-justify">
                        Sebagai mitra hukum andal, kami memberikan para ahli profesional di bidang hukum bisnis. Dengan menjunjung profesionalisme dalam memberikan layanan hukum yang berkualitas, kami menawarkan solusi hukum terbaik untuk kebutuhan bisnis Anda.
                      </p>
                    </div>
                  </li>
                  <li data-aos="fade-left" className="flex -mx-4">
                    <div className="px-4 ">
                      <span className="flex items-center justify-center w-16 h-16 mx-auto text-2xl font-bold text-secondary rounded-full font-heading bg-primary">
                        2
                      </span>
                    </div>
                    <div className="px-4 ">
                      <h3 className="my-2 text-xl font-semibold text-secondary ">
                        Berpengalaman
                      </h3>
                      <p className="leading-loose text-primary text-justify">
                        Pengalaman adalah kunci keberhasilan dalam menghadapi berbagai permasalahan hukum. Perjalanan lebih dari satu dekade di berbagai sektor industri telah berhasil menjawab penyelesaian kami dalam berbagai tantangan hukum pada bisnis multisektor
                      </p>
                    </div>
                  </li>
                  <li data-aos="fade-left" className="flex -mx-4">
                    <div className="px-4">
                      <span className="flex items-center justify-center w-16 h-16 mx-auto text-2xl font-bold text-secondary rounded-full font-heading bg-primary">
                        3
                      </span>
                    </div>
                    <div className="px-4">
                      <h3 className="my-2 text-xl font-semibold text-secondary">
                        Dukungan Kualitas
                      </h3>
                      <p className="leading-loose text-primary text-justify">
                        Sebagai konsultan hukum terpercaya, kami tidak berhenti pada memberikan nasihat hukum, tetapi juga membantu Anda melalui prosesnya. Pelayanan yang responsif menjadi poin utama untuk membantu ketika Anda membutuhkan bimbingan dan solusi tepat
                      </p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>
      </div>

      {/* List Services Lama */}
      {/* <section id="our-services">
        <div className="bg-white pt-16 w-full">
          <div className="flex md:flex-row flex-col justify-around text-center mx-auto w-10/12">

            Services 1
            <div data-aos="flip-right"
              className="bg-white md:w-4/12 text-primary px-8 m-8 py-12 rounded-md border-primary border-2"
              style={{ boxShadow: "6px 6px 0 rgba(10,10,10,.3)" }}
            >
              <img src={Lawfirm} className="text-center w-4/12 mx-auto pb-3" />
              <h3 className="font-semibold text-center mt-3 pb-2">
                Law Firm & Paten Merek
              </h3>
              <p className="font-light text-sm text-center">
                Tim ahli dalam hukum bisnis dan merek dagang untuk melindungi bisnis Anda dari risiko hukum
              </p>
            </div>

            Services 2
            <div data-aos="flip-right"
              className="bg-white md:w-4/12 text-primary px-8 m-8 py-12 rounded-md border-primary border-2"
              style={{ boxShadow: "6px 6px 0 rgba(10,10,10,.3)" }}
            >
              <img src={Legalbisnis} className="text-center w-4/12 mx-auto pb-0 pt-4" />
              <h3 className="font-semibold text-center mt-3 pb-2">
                Legalitas dan Izin Usaha
              </h3>
              <p className="font-light text-sm text-center">
                Membantu dalam proses pembuatan lisensi bisnis Anda
              </p>
            </div>

            Services 3
            <div data-aos="flip-right"
              className="bg-white md:w-4/12 text-primary px-8 m-8 py-12 rounded-md border-primary border-2"
              style={{ boxShadow: "6px 6px 0 rgba(10,10,10,.3)" }}
            >
              <img src={Agro} className="text-center w-4/12 mx-auto pb-0 pt-4" />
              <h3 className="font-semibold text-center mt-3 pb-2">
                Agro Resources
              </h3>
              <p className="font-light text-sm text-center">
                Memberikan solusi hukum untuk mendukung pertumbuhan dan pengelolaan sumber daya agrikultur Anda.
              </p>
            </div>

          </div>
        </div>

        <div className="bg-white pb-0 w-full">
          <div className="flex md:flex-row flex-col justify-around text-center mx-auto w-10/12">

            Services 4
            <div data-aos="flip-right"
              className="bg-white md:w-4/12 text-primary px-8 m-8 py-12 rounded-md border-secondary border-2"
              style={{ boxShadow: "6px 6px 0 rgba(10,10,10,.3)" }}
            >
              <img src={Time} className="text-center w-4/12 mx-auto pb-3" />
              <h3 className="font-semibold text-center mt-3 pb-2">Konstruksi & Manufacturing</h3>
              <p className="font-light text-sm text-center">
                Membantu litigasi proyek-proyek Anda, memberikan nasihat dalam setiap aspek produksi dan manufaktur</p>
            </div>

            Services 5
            <div data-aos="flip-right"
              className="bg-white md:w-4/12 text-primary px-8 m-8 py-12 rounded-md border-secondary border-2"
              style={{ boxShadow: "6px 6px 0 rgba(10,10,10,.3)" }}
            >
              <img src={Parcel} className="text-center w-4/12 mx-auto pb-0 pt-4" />
              <h3 className="font-semibold text-center mt-3 pb-2">
                Advertising
              </h3>
              <p className="font-light text-sm text-center">
                Membantu mengikuti perkembangan industri periklanan untuk pengembangan bisnis Anda</p>
            </div>

            Services 6
            <div data-aos="flip-right"
              className="bg-white md:w-4/12 text-primary px-8 m-8 py-12 rounded-md border-secondary border-2"
              style={{ boxShadow: "6px 6px 0 rgba(10,10,10,.3)" }}
            >
              <img src={Money} className="text-center w-4/12 mx-auto pb-0 pt-4" />
              <h3 className="font-semibold text-center mt-3 pb-2">Transportasi dan Logistik </h3>
              <p className="font-light text-sm text-center">
                Menawarkan solusi hukum yang solid untuk pengelolaan risiko dan regulasi arus perdagangan Internasional
              </p>
            </div>

          </div>
        </div>
      </section> */}

      {/* New List Layanan   */}
      <div className="w-full p-12 mt-32 mb-16 bg-white">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-2 xl:grid-cols-3">
          <div className="m-auto overflow-hidden rounded-lg shadow-lg cursor-pointer h-90 w-60 md:w-80 transform hover:scale-105 transition-transform duration-300 ease-in-out">
            <Link to="/layananlawfirm" className="block w-full h-full group ">
              <img alt="blog photo" src={HeroImage2} className="object-cover w-full max-h-60" />
              <div className="w-full p-4 bg-white">
                <p className="font-medium text-primary text-md text-center group-hover:text-secondary  ">
                  Law Firm & Paten Merk
                </p>
              </div>
            </Link>
          </div>
          <div className="m-auto overflow-hidden rounded-lg shadow-lg cursor-pointer h-90 w-60 md:w-80 transform hover:scale-105 transition-transform duration-300 ease-in-out">
            <Link to="/layananlegalitas" className="block w-full h-full group">
              <img alt="blog photo" src={HeroImage3} className="object-cover w-full max-h-60" />
              <div className="w-full p-4 bg-white">
                <p className="font-medium text-primary text-md text-center group-hover:text-secondary group-hover:scale-110 ">
                  Legalitas & Izin Usaha
                </p>
              </div>
            </Link>
          </div>
          <div className="m-auto overflow-hidden rounded-lg shadow-lg cursor-pointer h-90 w-60 md:w-80 transform hover:scale-105 transition-transform duration-300 ease-in-out">
            <Link to="/layananagro" className="block w-full h-full group">
              <img alt="blog photo" src={HeroImage4} className="object-cover w-full max-h-60" />
              <div className="w-full p-4 bg-white">
                <p className="font-medium text-primary text-md text-center group-hover:text-secondary group-hover:scale-110 ">
                  Agro Resources
                </p>
              </div>
            </Link>
          </div>
          <div className="m-auto overflow-hidden rounded-lg shadow-lg cursor-pointer h-90 w-60 md:w-80 transform hover:scale-105 transition-transform duration-300 ease-in-out">
            <Link to="/layanankonstruksi" className="block w-full h-full group ">
              <img alt="blog photo" src={HeroImage5} className="object-cover w-full max-h-60" />
              <div className="w-full p-4 bg-white">
                <p className="font-medium text-primary text-md text-center group-hover:text-secondary group-hover:scale-110 ">
                Konstruksi & Manufacturing
                </p>
              </div>
            </Link>
          </div>
          <div className="m-auto overflow-hidden rounded-lg shadow-lg cursor-pointer h-90 w-60 md:w-80 transform hover:scale-105 transition-transform duration-300 ease-in-out">
            <Link to="/layananadvertising" className="block w-full h-full group">
              <img alt="blog photo" src={HeroImage8} className="object-cover w-full max-h-60" />
              <div className="w-full p-4 bg-white">
                <p className="font-medium text-primary text-md text-center group-hover:text-secondary group-hover:scale-110 ">
                Advertising
                </p>
              </div>
            </Link>
          </div>
          <div className="m-auto overflow-hidden rounded-lg shadow-lg cursor-pointer h-90 w-60 md:w-80 transform hover:scale-105 transition-transform duration-300 ease-in-out">
            <Link to="/layanantransport" className="block w-full h-full group">
              <img alt="blog photo" src={HeroImage6} className="object-cover w-full max-h-60" />
              <div className="w-full p-4 bg-white">
                <p className="font-medium text-primary text-md text-center group-hover:text-secondary group-hover:scale-110 ">
                  Transportasi & Logistik
                </p>
              </div>
            </Link>
          </div>
        </div>
      </div>


    </div>
  );
}

export default Layanan;
